module.exports = __webpack_public_path__ + "img/spiele.8e3989c6.jpg";